var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pillars-navigation"},[_c('ul',_vm._l((_vm.pillarDataConsolidated(_vm.pillarId)
        .children),function(indicator,indicatorIndex){return _c('li',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],key:indicatorIndex,class:[
        _vm.getColorStateValue(
          indicator.value,
          indicator.ranges,
          indicator.errorOnValueFormula
        ),
        indicator.id === _vm.indicatorId ? 'selected' : '',
      ],attrs:{"title":_vm.$t(indicator.name)}},[_c('router-link',{attrs:{"to":'/reports/consolidated/' + _vm.pillarId + '/' + indicator.id}},[_vm._v(" "+_vm._s(_vm.$t(indicator.acronym))+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }